import traveler1Src from '../../shared/assets/images/traveler1.svg';
import traveler2Src from '../../shared/assets/images/traveler2.svg';
import traveler3Src from '../../shared/assets/images/traveler3.svg';
import captain1Src from '../../shared/assets/images/captain1.svg';
import captain2Src from '../../shared/assets/images/captain2.svg';
import captain3Src from '../../shared/assets/images/captain3.svg';
import cls from './GameEnd.module.scss';

export type contentType = {
  text: string;
  traveler: any;
  captain: any;
  cls: any;
};

export const ContentGameEnd: contentType[] = [
  {
    text: 'Благодарим за провизию, капитан! Вы как раз вовремя!',
    traveler: traveler1Src,
    captain: captain1Src,
    cls: cls.GameEnd1,
  },
  {
    text: 'Мы так рады вам, капитан! Новых запасов хватит надолго!',
    traveler: traveler2Src,
    captain: captain2Src,
    cls: cls.GameEnd2,
  },
  {
    text: 'Вы спасли нас, капитан! Наши запасы были на исходе. ',
    traveler: traveler3Src,
    captain: captain3Src,
    cls: cls.GameEnd3,
  },
];
